import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="grid min-h-screen place-items-center bg-softcream">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-tblue border-t-transparent" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="grid min-h-screen place-items-center bg-softcream px-6">
        <div className="max-w-md rounded-md border border-hborder bg-white p-8 text-center" data-testid="permission-denied">
          <h1 className="font-serif text-2xl text-heading">Permission needed</h1>
          <p className="mt-2 text-sm text-muted">Your account role does not have access to this area.</p>
        </div>
      </div>
    );
  }
  return children;
}
